import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';

const styles = {
  header: {
    margin: '0px'
  },
  fieldset: {
    borderRadius: '5px',
    marginBottom: '20px',
    borderStyle: 'hidden'
  }
};

class Translation extends Component {
  handleChange = (lang, name) => event => {
    this.props.handleChange(lang, name, event.target.value);
  };

  render() {
    const { saving, language, name, shortName, description } = this.props;

    return (
      <div>
        <fieldset style={styles.fieldset}>
          <legend>
            <h3 style={styles.header}>{language}</h3>
          </legend>
          <Grid container justify="center">
            <Grid item xs>
              <FormControl className="form-element">
                <TextField
                  id={language + '-name'}
                  disabled={saving}
                  value={name}
                  onChange={this.handleChange(language, 'name')}
                  label="Name"
                  margin="normal"
                />
              </FormControl>
            </Grid>
            <Grid item xs>
              <FormControl className="form-element">
                <TextField
                  id={language + '-short-name'}
                  disabled={saving}
                  value={shortName}
                  onChange={this.handleChange(language, 'shortName')}
                  label="Short Name"
                  margin="normal"
                />
              </FormControl>
            </Grid>
            <Grid item xs>
              <FormControl className="form-element">
                <TextField
                  id={language + '-description'}
                  disabled={saving}
                  value={description}
                  onChange={this.handleChange(language, 'description')}
                  label="Description"
                  margin="normal"
                />
              </FormControl>
            </Grid>
          </Grid>
        </fieldset>
      </div>
    );
  }
}

export default Translation;
